<template>
    <div>
        <el-form   v-model="skuForm" label-width="80px" size="mini" label-position="right">
            <el-form-item :label="objSku.skuTitle" >           
                    <el-cascader :class="{'discernFlag':!objSku.discernFlag}" v-model="objSku.skuId" :options="skuProtos" @change="onQuerySKU" clearable filterable
                    :props="{label:'name',value:'id'}"></el-cascader>         
            </el-form-item>
            <el-form-item label="数量">
                <el-input-number v-model="objSku.count" :min="1" :max="9999" label="请输入数量" @change="selectSku">
                </el-input-number>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: 'skuDan',
    props: ['sku', 'skuProtos'],
    data() {
        return {

            skuData: {
            },
            querySKU: [],
            skus: [],
            skuProtos: [],
        }
    },
    computed: {
        objSku() {
            return this.sku
        }

    },
    created() {
        this.skuData = this.sku
    },
    mounted() {

    },
    methods: {
        getSKUType() {
            let that = this
            this.$http.get('/api/company/skus', {
                params: {
                    gameId: this.objSku.gameId,
                    parentId: 0,
                    pricingType: this.objSku.pricingType
                }
            }).then(res => {
                if (res == null) {
                    return
                }
                that.types = res.data
            })
        },
        selectSkuType() {
            let that = this
            this.$http.get('/api/company/skus', {
                params: {
                    gameId: this.objSku.gameId,
                    parentId: this.objSku.skuTypeId,
                    pricingType: this.objSku.pricingType
                }
            }).then(res => {
                if (res == null) {
                    return
                }
                that.$nextTick(() => {
                    that.skus = res.data
                })

            })
        },
        onQuerySKU() {
            let that = this

            this.skuData = {
                gameId: this.objSku.gameId,
                pricingType: this.objSku.pricingType,
                skuId: this.objSku.skuId[1],
                count: this.objSku.count,
                id: this.objSku.id
            }
            if (this.skuData.skuId == undefined) {
                return false
            }
            this.$emit('selectSku', this.skuData)
        },
        selectSku() {
            let that = this
            this.skuData = {
                gameId: this.objSku.gameId,
                pricingType: this.objSku.pricingType,
                skuId: this.objSku.skuId[1],
                count: this.objSku.count,
                id: this.objSku.id
            }
            this.$emit('selectSku', this.skuData)
        },
    }
}
</script>

<style>
.discernFlag {
    border-color: #F56C6C;
    border-style: solid;
    padding: 3px;
}
</style>